import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-ios-add",
  "use": "icon-s-ios-add-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-ios-add\"><path d=\"M18 0a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm0 2H4a2 2 0 0 0-1.995 1.85L2 4v14a2 2 0 0 0 1.85 1.995L4 20h14a2 2 0 0 0 1.995-1.85L20 18V4a2 2 0 0 0-1.85-1.995zm-6.939 2.867a1 1 0 0 1 .993.883l.007.117v4.071h4.072a1 1 0 0 1 .117 1.994l-.117.007-4.072-.001v4.195a1 1 0 0 1-1.993.117l-.007-.117v-4.195H5.867a1 1 0 0 1-.117-1.992l.117-.007 4.194-.001V5.867a1 1 0 0 1 1-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol